module.exports = __webpack_public_path__ + "static/nerpa_text_2-92e4c35a482ca924f0621b2ac2bebbca.svg";